var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"my-64 p-24 bg-white border border-grey-lighter rounded shadow fixed-page-height"},[(_vm.src)?[_c('vue-pdf-embed',{attrs:{"source":_vm.src}})]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }